import { formatProductTitle, formatMoney } from './wishlist-utils.js';

const HEART_OUTLINE = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"  aria-label='Wishlist' data-wishlist-icon-outline>
      <path d="M12.0001 13.9396C10.9301 13.9396 10.0601 13.0696 10.0601 11.9996C10.0601 10.9296 10.9301 10.0596 12.0001 10.0596C13.0701 10.0596 13.9401 10.9296 13.9401 11.9996C13.9401 13.0696 13.0701 13.9396 12.0001 13.9396ZM12.0001 10.8096C11.3401 10.8096 10.8101 11.3396 10.8101 11.9996C10.8101 12.6596 11.3401 13.1896 12.0001 13.1896C12.6601 13.1896 13.1901 12.6596 13.1901 11.9996C13.1901 11.3396 12.6601 10.8096 12.0001 10.8096Z" fill="#101010"/>
      <path d="M15.4199 20.7298C13.8999 20.7298 12.5999 19.7698 12.0699 19.3098C10.7499 20.3898 8.15991 21.6398 6.21991 19.7498C4.30991 17.8898 5.19991 15.2398 5.60991 14.2998C4.37991 13.6198 2.67991 11.9998 3.35991 9.72976C4.03991 7.45976 6.43991 6.94977 7.89991 6.97977C8.05991 5.99977 8.72991 3.44977 11.6199 3.25977C13.1099 3.27977 14.2699 3.70977 15.0699 4.54977C15.9399 5.45977 16.1699 6.58977 16.2199 7.18977C17.2099 7.18977 19.7899 7.39977 20.6699 10.0398C21.2699 12.3198 19.6399 13.8998 18.4499 14.5698C19.1299 15.9798 19.6499 18.5298 17.5499 20.0098C16.8199 20.5198 16.0999 20.7198 15.4199 20.7198V20.7298ZM7.76991 7.73977C6.83991 7.73977 4.65991 7.95977 4.06991 9.94977C3.32991 12.4298 6.12991 13.7398 6.24991 13.7898L6.61991 13.9598L6.42991 14.3098C6.35991 14.4298 4.80991 17.3298 6.73991 19.2098C8.81991 21.2398 11.6999 18.6398 11.8199 18.5298L12.0899 18.2798L12.3399 18.5398C12.4399 18.6398 14.7999 21.0398 17.1199 19.3998C19.4199 17.7698 17.6899 14.7198 17.6199 14.5998L17.4099 14.2398L17.7899 14.0698C17.9099 14.0198 20.6199 12.7498 19.9599 10.2598C19.0599 7.57977 16.0499 7.93977 15.9199 7.95977L15.4899 8.01977V7.57977C15.4899 7.57977 15.5299 6.09977 14.5299 5.06977C13.8699 4.37977 12.8999 4.02977 11.6499 4.00977C8.78991 4.19977 8.61991 7.26977 8.60991 7.39977L8.58991 7.78977L8.19991 7.74977C8.19991 7.74977 8.01991 7.72977 7.77991 7.72977L7.76991 7.73977Z" fill="#101010"/>
      </svg>`;

const HEART_FILLED = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"  aria-label='Wishlist filled' class="hidden" data-wishlist-icon-filled>
      <path d="M20.6699 10.0495C19.7899 7.40953 17.2299 7.18953 16.2199 7.19953C16.1599 6.59953 15.9399 5.46953 15.0699 4.55953C14.2599 3.71953 13.1099 3.27953 11.6199 3.26953C8.72991 3.45953 8.04991 6.00953 7.89991 6.98953C6.44991 6.95953 4.02991 7.46953 3.35991 9.73953C2.67991 12.0095 4.37991 13.6195 5.60991 14.3095C5.19991 15.2495 4.31991 17.9095 6.21991 19.7595C8.15991 21.6495 10.7499 20.3995 12.0699 19.3195C12.6099 19.7795 13.8999 20.7395 15.4199 20.7395C16.0999 20.7395 16.8299 20.5495 17.5499 20.0295C19.6499 18.5395 19.1299 15.9995 18.4499 14.5895C19.6399 13.9195 21.2799 12.3295 20.6699 10.0595V10.0495ZM11.9999 13.9395C10.9299 13.9395 10.0599 13.0695 10.0599 11.9995C10.0599 10.9295 10.9299 10.0595 11.9999 10.0595C13.0699 10.0595 13.9399 10.9295 13.9399 11.9995C13.9399 13.0695 13.0699 13.9395 11.9999 13.9395Z" fill="#101010"/>
      <path d="M12.0001 13.1896C12.6573 13.1896 13.1901 12.6568 13.1901 11.9996C13.1901 11.3424 12.6573 10.8096 12.0001 10.8096C11.3428 10.8096 10.8101 11.3424 10.8101 11.9996C10.8101 12.6568 11.3428 13.1896 12.0001 13.1896Z" fill="#101010"/>
      </svg>`;

class WishlistShared extends HTMLElement {
  constructor() {
    super();
    this.controller = new AbortController();

    this.grid = null;
    this.loadingState = null;
    this.errorState = null;
    this.emptyState = null;
    this.subtitle = null;
    this.apiUrl = null;
    this.customerId = null;
    this.coloursLabel = null;
  }

  connectedCallback() {
    this.apiUrl = window.__cbApiUrl;
    this.customerId = this.getAttribute('data-customer-id');
    this.coloursLabel = this.getAttribute('data-colours-label') || 'colours';
    this.country = this.getAttribute('data-country') || 'DK';

    this.grid = this.querySelector('[data-shared-grid]');
    this.loadingState = this.querySelector('[data-shared-loading]');
    this.errorState = this.querySelector('[data-shared-error]');
    this.emptyState = this.querySelector('[data-shared-empty]');
    this.subtitle = this.querySelector('[data-shared-subtitle]');

    this.loadWishlist();
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  async loadWishlist() {
    const pathParts = window.location.pathname.split('/');
    const encryptedId = pathParts.pop() || pathParts.pop();

    if (!encryptedId || !this.apiUrl) {
      this.showError();
      return;
    }

    try {
      const response = await fetch(
        `${this.apiUrl}/wishlist/shared/${encryptedId}?country=${encodeURIComponent(this.country)}`,
        { signal: this.controller.signal }
      );

      if (!response.ok) {
        this.showError();
        return;
      }

      const data = await response.json();

      if (data.customer_name && this.subtitle) {
        this.subtitle.textContent = `${data.customer_name}'s Wishlist`;
      }

      if (!data.wishlist || data.wishlist.length === 0) {
        this.showEmpty();
        return;
      }

      this.renderProducts(data.wishlist);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('wishlist-shared: error loading wishlist', error);
        this.showError();
      }
    }
  }

  renderProducts(wishlist) {
    this.loadingState?.classList.add('hidden');

    const fragment = document.createDocumentFragment();

    for (const item of wishlist) {
      const product = item.node || item;
      fragment.appendChild(this.createCard(product));
    }

    this.grid?.appendChild(fragment);
    this.grid?.classList.remove('hidden');
  }

  createCard(product) {
    const handle = product.handle;
    const numericId = product.id ? product.id.split('/').pop() : '';
    const formattedTitle = formatProductTitle(product);

    // Images
    const firstImage = product.images?.edges?.[0]?.node?.url || '';
    const secondImage = product.images?.edges?.[1]?.node?.url || '';
    const imageUrl = firstImage ? `${firstImage}&width=600` : '';

    // Metafields
    const metafields = (product.metafields?.edges || []).map((e) => e.node);
    const videoMeta = metafields.find(
      (m) => m.key === 'product_page.hero_video_vimeo'
    );
    const connectedMeta = metafields.find(
      (m) => m.key === 'custom.connected_products'
    );

    const videoUrl = videoMeta?.value || '';
    let colorCount = 0;
    if (connectedMeta?.value) {
      try {
        colorCount = JSON.parse(connectedMeta.value).length + 1;
      } catch {
        // ignore
      }
    }

    // Tag badge
    let tagLabel = '';
    if (product.tags) {
      for (const tag of product.tags) {
        if (tag.startsWith('label:')) {
          tagLabel = tag.split(':').pop().trim().replace(/-/g, ' ');
          break;
        }
      }
    }

    // Prices — API returns decimal amounts (not cents) via contextualPricing when ?country= is passed
    const pricing = product.contextualPricing?.priceRange;
    const minPrice = parseFloat(pricing?.minVariantPrice?.amount || 0);

    let compareAtPrice = 0;
    const variants = product.variants?.edges || [];
    for (const v of variants) {
      const cap = parseFloat(v.node.contextualPricing?.compareAtPrice?.amount);
      if (cap && cap > compareAtPrice) compareAtPrice = cap;
    }

    // Media HTML
    const hoverImageUrl =
      !videoUrl && secondImage ? `${secondImage}&width=600` : '';

    let mediaHtml = '';
    if (videoUrl) {
      mediaHtml = `<video data-lazy-src="${videoUrl}" poster="${imageUrl}" autoplay loop muted playsinline class="w-full h-full object-cover"></video>`;
    } else if (imageUrl) {
      mediaHtml = `<img src="${imageUrl}" alt="${formattedTitle}" class="w-full h-full object-cover" loading="lazy" />`;
    }

    const hoverHtml = hoverImageUrl
      ? `<div class="w-full aspect-[2/3] !absolute inset-0 opacity-0 group-hover/image:opacity-100 transition-opacity duration-300"><img src="${hoverImageUrl}" alt="${formattedTitle}" class="w-full h-full object-cover" loading="lazy" /></div>`
      : '';

    const tagHtml = tagLabel
      ? `<span class="text-body absolute right-0 top-0 p-2">${tagLabel}</span>`
      : '';

    // Price HTML
    const comparePriceHtml =
      compareAtPrice > minPrice
        ? `<p class="line-through">${formatMoney(compareAtPrice * 100)}</p>`
        : '';

    // Wishlist heart HTML
    const customerAttr = this.customerId
      ? `data-customer-id="${this.customerId}"`
      : '';
    const colorAttr = colorCount ? `data-color-count="${colorCount}"` : '';
    const videoAttr = videoUrl ? `data-video-url="${videoUrl}"` : '';

    const heartHtml = `
      <wishlist-button
        data-product-id="${numericId}"
        data-product-handle="${handle}"
        ${customerAttr}
        ${colorAttr}
        ${videoAttr}
        class="shrink-0"
      >
        <button type="button" class="flex cursor-pointer items-center px-2" aria-pressed="false">
          ${HEART_OUTLINE}
          ${HEART_FILLED}
        </button>
      </wishlist-button>`;

    // Colours HTML
    const colourClasses = `text-body text-button-text-disabled no-underline${colorCount > 0 ? '' : ' invisible'}`;
    const coloursHtml = `<a href="/products/${handle}" class="${colourClasses}">${colorCount} ${this.coloursLabel}</a>`;

    // Build the card
    const card = document.createElement('div');
    card.className = 'relative flex flex-col gap-2';
    card.setAttribute('data-product-card', '');
    card.innerHTML = `
      <div class="group/image relative w-full" data-product-card-image>
        <a href="/products/${handle}" class="flex flex-col gap-2 no-underline" aria-label="${formattedTitle}">
          <div class="w-full aspect-[2/3] h-full">
            ${mediaHtml}
          </div>
          ${hoverHtml}
          ${tagHtml}
        </a>
      </div>
      <div class="flex flex-col gap-[2px]" data-product-info>
        <div class="flex w-full items-start justify-between">
          <div class="text-body flex min-w-0 flex-1 flex-col gap-1">
            <a href="/products/${handle}" class="line-clamp-2 no-underline capitalize">${formattedTitle}</a>
            <a href="/products/${handle}" class="flex flex-row gap-2 no-underline">
              ${comparePriceHtml}
              <p>${formatMoney(minPrice * 100)}</p>
            </a>
          </div>
          ${heartHtml}
        </div>
        ${coloursHtml}
      </div>
    `;

    return card;
  }

  showError() {
    this.loadingState?.classList.add('hidden');
    this.errorState?.classList.remove('hidden');
  }

  showEmpty() {
    this.loadingState?.classList.add('hidden');
    this.emptyState?.classList.remove('hidden');
  }
}

if (!customElements.get('wishlist-shared')) {
  customElements.define('wishlist-shared', WishlistShared);
}
